import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, combineLatest, forkJoin, Observable, of } from 'rxjs';
import { tap, map, switchMap, filter, debounceTime } from 'rxjs/operators';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { CondReglModel } from 'src/app/shared/models/simple-types/cond-regl.model';
import { ModeReglModel } from 'src/app/shared/models/simple-types/modeRegl.model';
import { TvaModel } from 'src/app/shared/models/simple-types/tva.model';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BpLineService } from 'src/app/shared/services/bp/bp-line.service';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { CondReglService } from 'src/app/shared/services/simple/cond-regl.service';
import { ModeReglService } from 'src/app/shared/services/simple/mode-regl.service';
import { TvaService } from 'src/app/shared/services/simple/tva.service';
import { ArticleService } from 'src/app/shared/services/societe-linked/article.service';
import { StateService } from 'src/app/shared/services/state.service';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { FournisseurModel } from 'src/app/shared/models/societe-linked/fournisseur.model';
import { ArticleModel } from 'src/app/shared/models/societe-linked/article.model';
import { Ca2Model } from 'src/app/shared/models/societe-linked/ca2.model';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { BpLineModel } from 'src/app/shared/models/societe-linked/bp/bp-line.model';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { Ca1Service } from 'src/app/shared/services/societe-linked/ca1.service';
import { FournisseurService } from 'src/app/shared/services/societe-linked/fournisseur.service';
import { Ca2Service } from 'src/app/shared/services/societe-linked/ca2.service';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { BPLINEVALIDATORS, BPVALIDATORS, FormInfo } from 'src/app/shared/constants/bp-validators';
import { CompService } from 'src/app/shared/services/societe-linked/comp.service';
import { CompModel } from 'src/app/shared/models/societe-linked/comp.model';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { BpValidationModel } from 'src/app/shared/dtos/bpValidationModel';
import { DocumentService } from 'src/app/shared/services/simple/document.service';
import { DocumentModel } from 'src/app/shared/models/simple-types/document.model';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { CgChargeService } from 'src/app/shared/services/simple/cg-charge.service';
import { AddCommentModalComponent } from 'src/app/shared/components/modals/add-comment/add-comment-modal.component';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';

export class DetailBpinfos {
  sites: SiteModel[] = [];
  ca1s: Ca1Model[] = [];
  fournisseurs: FournisseurModel[] = [];
  condRegls: CondReglModel[] = [];
  modeRegls: ModeReglModel[] = [];
}
export class DetailBpLineinfos {
  articles: ArticleModel[] = [];
  cgCharges: CgChargeModel[] = [];
  ca1s: Ca1Model[] = [];
  ca2s: Ca2Model[] = [];
  comps: CompModel[] = [];
  nas: NaModel[] = [];
  tvas: TvaModel[] = [];
}

@Injectable()
export class BpComponentsService {
  society: SocieteModel;
  user: string;
  private detailBpInfosSource = new BehaviorSubject<DetailBpinfos>(null);
  private detailBpLineInfosSource: BehaviorSubject<DetailBpLineinfos>[] = [];
  private defaultDetailBpLineInfosSource: BehaviorSubject<DetailBpLineinfos> = new BehaviorSubject(new DetailBpLineinfos());
  detailBpInfos = this.detailBpInfosSource.asObservable();
  private defaultDetailBpLineInfos = this.defaultDetailBpLineInfosSource.asObservable();
  amountHorsTaxe = 0;
  amountTtc = 0;
  private bp: BpModel;
  observer = new BehaviorSubject<BpModel>(null);
  public bpSubscriber = this.observer.asObservable();

  constructor(
    public dialog: MatDialog,
    protected router: Router,
    protected toastr: ToastrService,
    protected bpService: BpService,
    protected bpLineService: BpLineService,
    protected siteService: SiteService,
    protected ca1Service: Ca1Service,
    protected fournisseurService: FournisseurService,
    protected modeReglService: ModeReglService,
    protected condReglService: CondReglService,
    protected compService: CompService,
    private articleService: ArticleService,
    private documentService: DocumentService,
    private ca2Service: Ca2Service,
    private naService: NaService,
    private tvaService: TvaService,
    private state: StateService,
    private societeService: SocieteService,
    private cgChargeService: CgChargeService) {
    this.state.society.subscribe(result => {
      this.society = result;
    });
    this.state.user.subscribe(result => {
      this.user = result;
    });
  }

  getBpLineRef(i: number): Observable<DetailBpLineinfos> {
    let bpLineInfo: BehaviorSubject<DetailBpLineinfos> = this.detailBpLineInfosSource[i];
    if (!bpLineInfo) {
      bpLineInfo = this.loadDetailBpLineFromDefault();
      this.detailBpLineInfosSource.push(bpLineInfo);
    }
    return bpLineInfo;
  }


  loadDetailBp(): Observable<DetailBpinfos> {
    const infos = new DetailBpinfos();
    this.state.society.pipe(filter(d => d !== null), debounceTime(300), switchMap(soc => {
    return forkJoin<any>([
      this.siteService.getFromSociete(this.society.id).pipe(tap(objs => infos.sites = objs)),
      this.fournisseurService.getFromSociete(this.society.id).pipe(tap(objs => infos.fournisseurs = objs)),
      this.condReglService.getAll().pipe(tap(objs => infos.condRegls = objs)),
      this.modeReglService.getAll().pipe(tap(objs => infos.modeRegls = objs))
    ]).pipe(map(_ => infos));
  }))
  .subscribe(_ => {
    this.detailBpInfosSource.next(infos);
  });
    return this.detailBpInfos;
  }

  loadDetailBpLineFromDefault(): BehaviorSubject<DetailBpLineinfos> {
    const infos = new BehaviorSubject<DetailBpLineinfos>(new DetailBpLineinfos());
    this.defaultDetailBpLineInfosSource.subscribe(infoSource => {
      infos.next(infoSource);
    });
    return infos;
  }

  removeBpLine(bpForm: UntypedFormGroup, i): void {
    const bpLineForm = bpForm.get('bpLines') as UntypedFormArray;
    bpLineForm.removeAt(i);
    const removed = this.detailBpLineInfosSource.slice(i, 1);
  }

  cancelCreatedLine(): void {
    this.detailBpLineInfosSource.pop();
  }

  loadDefaultDetailBpLine(): void {
    this.defaultDetailBpLineInfosSource.next(new DetailBpLineinfos());
    this.state.society.pipe(filter(d => d !== null), debounceTime(300), switchMap(soc => {
      return forkJoin<any>([
        // Article à charger lors de la saisie du Site
        // Comp à charger lors de la saisie du NA
        this.cgChargeService.getAll().pipe(tap(objs => {
          const detail = this.defaultDetailBpLineInfosSource.value;
          detail.cgCharges = objs;
          this.defaultDetailBpLineInfosSource.next(detail);
          return null;
        })),
        this.tvaService.getAll().pipe(tap(objs => {
          const detail = this.defaultDetailBpLineInfosSource.value;
          detail.tvas = objs;
          this.defaultDetailBpLineInfosSource.next(detail);
          return null;
        }))
      ]);
    })).subscribe(_ => {
    });
  }

  fuseModelAndFormsBpLine(bpLine: BpLineModel, bpLineForm: UntypedFormGroup): BpLineModel {
    const myBpLine: BpLineModel = bpLineForm.getRawValue();
    return myBpLine;
  }

  fuseModelAndFormsBc(bp: BpModel, bpForm: UntypedFormGroup): BpModel {
    const myBpLine: BpModel = bpForm.getRawValue();
    return myBpLine;
  }
  getBpNumFormGroup(): UntypedFormGroup {
    const bpNumForm = new UntypedFormGroup({
      numBp: new UntypedFormControl('', Validators.required),
    });
    return bpNumForm;
  }

  createBpLineForm(bpLine: BpLineModel, bpLineValidators: Map<string, FormInfo>): UntypedFormGroup {
    const form = new UntypedFormGroup({});
    for (const [key, _] of bpLineValidators.entries()) {
      const control =
        new UntypedFormControl({ value: bpLine[key], disabled: bpLineValidators.get(key).disabled }, bpLineValidators.get(key).validators);
      form.addControl(key, control);
    }
    return form;
  }

  refusBp(bpForRefus: BpValidationModel): Observable<BpModel> {
    return this.bpService.refusBp(bpForRefus).pipe(
      tap(bpUpd => {
        this.toastr.success('BP réfusé');
      }));
  }

  validateBp(bpForValidation: BpValidationModel): Observable<BpModel> {
    return this.bpService.validateBp(bpForValidation).pipe(
      tap(bpUpd => {
        this.toastr.success('BP validé');
      }));
  }

  public getBpLineForm(bpLine: BpLineModel, bpLineValidators: Map<string, FormInfo>, i: number): UntypedFormGroup {
    const form = this.createBpLineForm(bpLine, bpLineValidators);
    this.getBpLineRef(i);
    this.getBpLineFormEvent(form, i);
    return form;
  }

  getBpLineFormEvent(bpLineForm: UntypedFormGroup, i: number): void {

   // Get nas by current society and selected ca1 (idSociete and codeCa1)
   let oldCodeCa1 = '';
   combineLatest([
     bpLineForm.get('codeCa1').valueChanges,
     bpLineForm.get('libelleCa1').valueChanges,
     this.detailBpLineInfosSource[i],
     this.state.society])
     .pipe(
       filter(([code, libelle, detailBpLineInfos, soc]) => detailBpLineInfos && soc && oldCodeCa1 !== code),
       tap(([code, libelle, detailBpLineInfos, soc]) => {
         if (!code && !libelle) {
           oldCodeCa1 = code;
           bpLineForm.get('codeNa').setValue('');
           bpLineForm.get('libelleNa').setValue('');
           const detailBpLineInfo = this.detailBpLineInfosSource[i].value;
           oldNaCode = '';
           if (detailBpLineInfo && detailBpLineInfo.comps && detailBpLineInfo.nas.length > 0) {
             detailBpLineInfo.nas = [];
             this.detailBpLineInfosSource[i].next(detailBpLineInfo);
           }
         }
         return [code, libelle, detailBpLineInfos, soc];
       }),
       filter(([code, libelle, detailBpLineInfos, soc]) => code && libelle),
       switchMap(([code, libelle, detailBpLineInfos, soc]) => {
         oldCodeCa1 = code;
         return this.naService.getFromCa1(soc.id, code);
     }))
     .subscribe(nas => {
       const detailBpLineInfo = this.detailBpLineInfosSource[i].value;
       detailBpLineInfo.nas = nas;
       this.detailBpLineInfosSource[i].next(detailBpLineInfo);
     });
   // autoLoad  from NA
   let oldNaCode = '';
   combineLatest([
     bpLineForm.get('codeNa').valueChanges,
     bpLineForm.get('libelleNa').valueChanges,
     this.detailBpLineInfosSource[i],
     this.state.society
    ]).pipe(
       filter(([code, libelle, detail, soc]) => {
         return detail !== null && soc && oldNaCode !== code + libelle;
       }),
       tap(([code, libelle, detail, soc]) => {
         if (!code && !libelle) {
           oldNaCode = code + libelle;
           bpLineForm.get('codeComp').setValue('');
           bpLineForm.get('libelleComp').setValue('');
           bpLineForm.get('codeCa2').setValue('');
           bpLineForm.get('libelleCa2').setValue('');
           const detailBpLineInfo = this.detailBpLineInfosSource[i].value;
           oldNaCode = '';
           if (detailBpLineInfo && detailBpLineInfo.comps && detailBpLineInfo.comps.length > 0) {
             detailBpLineInfo.comps = [];
             this.detailBpLineInfosSource[i].next(detailBpLineInfo);
           }
           if (detailBpLineInfo && detailBpLineInfo.ca2s && detailBpLineInfo.ca2s.length > 0) {
            detailBpLineInfo.ca2s = [];
            this.detailBpLineInfosSource[i].next(detailBpLineInfo);
          }
         }
         return [code, libelle, detail, soc];
       }),
       filter(([code, libelle, detail, soc]) => {
         const na = this.detailBpLineInfosSource[i].value.nas.find(obj => obj.code === code && obj.libelle === libelle);
         return na && code && libelle;
       }),
       switchMap(([code, libelle, detail, soc]) => {
         oldNaCode = code + libelle;
         const na = this.detailBpLineInfosSource[i].value.nas.find(obj => obj.code === code && obj.libelle === libelle);
         return combineLatest([this.compService.getFromNa(na.id), this.ca2Service.getFromNaCa1(soc.id, bpLineForm.get('codeCa1').value, code, 'BC')]);
       }))
     .subscribe(([comps, ca2s]) => {
       const detail = this.detailBpLineInfosSource[i].value;
       if (comps.length > 0) {
         detail.comps = comps;
         bpLineForm.get('codeComp').setValidators(Validators.required);
         bpLineForm.get('codeComp').enable();
       } else {
         bpLineForm.get('codeComp').setValidators([]);
         bpLineForm.get('codeComp').disable();
         detail.comps = [];
         bpLineForm.get('codeComp').setValue('');
         bpLineForm.get('libelleComp').setValue('');
       }
       if (ca2s.length > 0) {
        detail.ca2s = ca2s;
        bpLineForm.get('codeCa2').enable();
      } else {
        detail.ca2s = [];
        bpLineForm.get('codeCa2').disable();
        bpLineForm.get('codeCa2').setValue('');
        bpLineForm.get('libelleCa2').setValue('');
      }
       this.detailBpLineInfosSource[i].next(detail);
     });

   // autoSet cgCharge & Complement when Na selected
   let oldNaCodeToCgCharge = '';
   combineLatest([
     bpLineForm.get('codeNa').valueChanges,
     bpLineForm.get('libelleNa').valueChanges,
     this.detailBpLineInfosSource[i]])
     .pipe(
       filter(([code, libelle, detail]) => detail !== null && code !== oldNaCodeToCgCharge),
       tap(([code, libelle, detail]) => {
         if (!code && !libelle) {
           bpLineForm.get('codeCgCharge').setValue('');
           bpLineForm.get('libelleCgCharge').setValue('');
           oldNaCodeToCgCharge = '';
           const detailBpLineInfo = this.detailBpLineInfosSource[i].value;
           if (detailBpLineInfo && detailBpLineInfo.cgCharges && detailBpLineInfo.cgCharges.length > 0) {
             this.detailBpLineInfosSource[i].next(detailBpLineInfo);
           }
           return [code, libelle, detail];
         }
       }),
       filter(([code, libelle, detail]) => {
        const naSelected = detail.nas.find(na => na.code === code && na.libelle === libelle);
        return naSelected !== undefined && naSelected !== null;
      }))
     .subscribe(([code, libelle, detail]) => {
       oldNaCodeToCgCharge = code;
       if (detail.nas.length > 0) {
         const naSelected = detail.nas.find(na => na.code === code && na.libelle === libelle);
         if (naSelected && detail.cgCharges.length > 0) {
           const cgChargeAuto = detail.cgCharges.find(cg => cg.code === naSelected.cgCharge);
           if (cgChargeAuto) {
             bpLineForm.get('codeCgCharge').setValue(cgChargeAuto.code);
             bpLineForm.get('libelleCgCharge').setValue(cgChargeAuto.libelle);
            }
         }
       }
     });

    // Calcul du montant HT quand le prix unitaire.
   combineLatest([bpLineForm.get('pu').valueChanges, this.detailBpLineInfosSource[i]])
      .subscribe(([prixU, detail]) => {
        if (prixU && detail) {
          if (prixU > 0) {
            this.amountHorsTaxe = prixU * bpLineForm.get('qte').value;
            bpLineForm.get('ht').setValue(0);
            bpLineForm.get('ht').patchValue(this.amountHorsTaxe);
            if (bpLineForm.get('tauxTva').value >= 0 ) {
              const tva = detail.tvas.find(t => t.code === bpLineForm.get('codeTva').value);
              if (tva) {
                const taux = tva.autoIntra ? 0 : tva.taux;
                this.amountTtc = this.amountHorsTaxe + ((this.amountHorsTaxe * taux) / 100);
              }
              bpLineForm.get('ttc').setValue(0);
              bpLineForm.get('ttc').patchValue(this.amountTtc);
            }
          }
        }
      });

    // Calcul du montant HT quand la quantité change.
   combineLatest([bpLineForm.get('qte').valueChanges])
      .subscribe(([qt]) => {
        if (qt) {
          if (qt > 0) {
            this.amountHorsTaxe = qt * bpLineForm.get('pu').value;
            bpLineForm.get('ht').setValue(0);
            bpLineForm.get('ht').patchValue(this.amountHorsTaxe);
          }
        }
      });

    // Calcul du montant TTC quand le taux tva change.
   combineLatest([bpLineForm.get('tauxTva').valueChanges, this.detailBpLineInfosSource[i]])
      .subscribe(([tauxTva, detail]) => {
        if (this.amountHorsTaxe && tauxTva && detail) {
          if (this.amountHorsTaxe > 0 && tauxTva >= 0) {
            const tva = detail.tvas.find(t => t.code === bpLineForm.get('codeTva').value);
            if (tva) {
              const taux = tva.autoIntra ? 0 : tva.taux;
              this.amountTtc = this.amountHorsTaxe + ((this.amountHorsTaxe * taux) / 100);
            }
            bpLineForm.get('ttc').setValue(0);
            bpLineForm.get('ttc').patchValue(this.amountTtc);
          }
        }
      });

      // Calcul du montant TTC quand le ht change.
   combineLatest([bpLineForm.get('ht').valueChanges, this.detailBpLineInfosSource[i]])
      .subscribe(([ht, detail]) => {
        if (ht && bpLineForm.get('tauxTva').value && detail) {
          if (this.amountHorsTaxe !== 0 && bpLineForm.get('ttc').value > 0) {
            const tva = detail.tvas.find(t => t.code === bpLineForm.get('codeTva').value);
            if (tva) {
              const taux = tva.autoIntra ? 0 : tva.taux;
              this.amountTtc = this.amountHorsTaxe + ((this.amountHorsTaxe * taux) / 100);
            }
            bpLineForm.get('ttc').setValue(0);
            bpLineForm.get('ttc').patchValue(this.amountTtc);
          }
        }
    });
  }

  public getBpForm(bp: BpModel, bpValidators: Map<string, FormInfo>, bpLineValidators: Map<string, FormInfo>): UntypedFormGroup {
    // Gen du BP
    const form = new UntypedFormGroup({});
    for (const [key, value] of bpValidators.entries()) {
      if (key !== 'bpLines' && key !== 'cycleBps') {
        const control = new UntypedFormControl({ value: bp[key], disabled: bpValidators.get(key).disabled }, bpValidators.get(key).validators);
        form.addControl(key, control);
      }
    }
    const bpFormArray = new UntypedFormArray([]);
    this.loadDefaultDetailBpLine();
    if (bp.bpLines.length > 0) {
      let i = 0;
      for (const bpLine of bp.bpLines) {
        bpFormArray.push(this.getBpLineForm(bpLine, bpLineValidators, i));
        i++;
      }
    }
    bpFormArray.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    form.addControl('bpLines', bpFormArray);
    return form;
  }

  private getBpFormEvent(bpForm: UntypedFormGroup): void {

     // Get ca1s by current society and selected site (idSociete and codeSite)
     let oldCodeSiteToCa1s = '';
     combineLatest([
         bpForm.get('codeSite').valueChanges,
         bpForm.get('libelleSite').valueChanges,
         // TODO impact de la suprresion ?
         this.defaultDetailBpLineInfosSource,
         this.detailBpInfos,
         this.state.society])
       .pipe(filter(([code, libelle, detailBpLineInfos, detailBpInfos, soc]) => {
         return code && soc && libelle && detailBpLineInfos !== null && detailBpInfos !== null && oldCodeSiteToCa1s !== code;
       }),
         switchMap(([code, libelle, detailBpLineInfos, detailBpInfos, soc]) => {
           oldCodeSiteToCa1s = code;
           return this.ca1Service.getFromSite(soc.id, code);
         })
       )
       .subscribe(ca1s => {
         const detailsBpInfo = this.detailBpInfosSource.value;
         const detailBpLineInfo = this.defaultDetailBpLineInfosSource.value;
         detailsBpInfo.ca1s = ca1s;
         detailBpLineInfo.ca1s = ca1s;
         this.detailBpInfosSource.next(detailsBpInfo);
         this.defaultDetailBpLineInfosSource.next(detailBpLineInfo);
       });

    // autoSet SiteLivraison when Site selected
     combineLatest([bpForm.get('codeSite').valueChanges, bpForm.get('libelleSite').valueChanges, this.detailBpInfos])
      .pipe(filter(([code, libelle, detail]) => code && libelle && detail !== null))
      .subscribe(([code, libelle, detail]) => {
        if (detail.sites) {
          const siteSelected = detail.sites.find(site => site.code === code && site.libelle === libelle);
          if (siteSelected) {
            bpForm.get('codeSiteLivraison').setValue(siteSelected.code);
            bpForm.get('libelleSiteLivraison').setValue(siteSelected.libelle);
          }
        }
    });
    // autoSet LigneCa1 when Ca1 Selected
     combineLatest([
      bpForm.get('codeCa1').valueChanges,
      bpForm.get('libelleCa1').valueChanges,
      this.state.society
    ]).pipe(
        filter(([code, libelle, soc]) => code && libelle && soc !== null),
        switchMap(([code, libelle, soc]) => {
          return this.naService.getFromCa1(soc.id, code);
      })).subscribe((nas: NaModel[]) => {
        const detailBpLineInfo = this.defaultDetailBpLineInfosSource.value;
        detailBpLineInfo.nas = nas;
        this.defaultDetailBpLineInfosSource.next(detailBpLineInfo);
      });

     combineLatest([bpForm.get('dFacture').valueChanges, this.detailBpInfos])
      .pipe(filter(([dFacture, detail]) => dFacture && detail !== null))
      .subscribe(([dFacture, detail]) => {
        const codeCondRegl = bpForm.get('codeCondRegl').value;
        if (dFacture && codeCondRegl && detail) {
          const mode = detail.condRegls.find(condRegl => condRegl.code === codeCondRegl) ?
                            detail.condRegls.find(condRegl => condRegl.code === codeCondRegl).mode : null;
          if (mode) {
            const array = mode.split('.');
            let date = new Date(dFacture);
            // aller a la fin du mois si == 1
            if (Number(array[0]) === 1) {
              dFacture = new Date(date.getFullYear(), date.getMonth(), this.lastDayOfTheMonth(date));
            }
            // Ajouter les jours selon la condition de réglement
            date.setDate(dFacture.getDate() + Number(array[1]));
            // aller a la fin du mois si == 1
            if (Number(array[2]) === 1) {
              date = new Date(date.getFullYear(), date.getMonth(), this.lastDayOfTheMonth(date));
            }
            bpForm.get('dRegl').setValue(date);
          }
        }
      });

     combineLatest([bpForm.get('codeCondRegl').valueChanges, this.detailBpInfos])
      .pipe(filter(([codeCondRegl, detail]) => codeCondRegl && detail !== null))
      .subscribe(([codeCondRegl, detail]) => {
        let dFacture = bpForm.get('dFacture').value;
        if (dFacture && codeCondRegl && detail) {
          const mode = detail.condRegls.find(condRegl => condRegl.code === codeCondRegl) ?
                            detail.condRegls.find(condRegl => condRegl.code === codeCondRegl).mode : null;
          if (mode) {
            const array = mode.split('.');
            let date = new Date(dFacture);
            // aller a la fin du mois si == 1
            if (Number(array[0]) === 1) {
              dFacture = new Date(date.getFullYear(), date.getMonth(), this.lastDayOfTheMonth(date));
            }
            // Ajouter les jours selon la condition de réglement
            date.setDate(dFacture.getDate() + Number(array[1]));
            // aller a la fin du mois si == 1
            if (Number(array[2]) === 1) {
              date = new Date(date.getFullYear(), date.getMonth(), this.lastDayOfTheMonth(date));
            }
            bpForm.get('dRegl').setValue(date);
          }
        }
      });
  }

  lastDayOfTheMonth(date: Date): number{
      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  getCreateBpFormGroup(bp: BpModel): UntypedFormGroup {
    const bpForm = this.getBpForm(bp, BPVALIDATORS.CREATE, BPLINEVALIDATORS.CREATE);
    // Ajout des regles de chargements de données
    this.getBpFormEvent(bpForm);
    bpForm.patchValue(bp);

    return bpForm;
  }

  getValidateBpFormGroup(bp: BpModel): UntypedFormGroup {
    const bpForm = this.getBpForm(bp, BPVALIDATORS.VALIDATE, BPLINEVALIDATORS.VALIDATE);
    return bpForm;
  }

  getVisualizeBpFormGroup(bp: BpModel): UntypedFormGroup {
    const bpForm = this.getBpForm(bp, BPVALIDATORS.VISUALISE, BPLINEVALIDATORS.VISUALISE);
    return bpForm;
  }

  getFacturateBpFormGroup(bp: BpModel): UntypedFormGroup {
    const bpForm = this.getBpForm(bp, BPVALIDATORS.FACTURE, BPLINEVALIDATORS.FACTURE);
    this.getBpFormEvent(bpForm);
    return bpForm;
  }

  getBpFormGroup(fieldsDisabled: boolean = false): UntypedFormGroup {
    const bpForm = new UntypedFormGroup({
      code: new UntypedFormControl({ value: '1', disabled: true }),
      libelle: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, [Validators.required, Validators.maxLength(30)]),
      ca1Lib: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.required),
      siteLib: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.required),
      siteLivraisonLib: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.required),
      fournisseurLib: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.required),
      condReglLib: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.required),
      modeReglLib: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.required),
      commentaires: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.maxLength(255)),
      refFourn: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.maxLength(30)),
      motif: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.maxLength(80)),
      numFacture: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.maxLength(30)),
      status: new UntypedFormControl({ value: '', disabled: fieldsDisabled }, Validators.maxLength(30)),
      ht: new UntypedFormControl({ value: 0, disabled: fieldsDisabled }, [Validators.maxLength(30), Validators.required]),
      tva: new UntypedFormControl({ value: 0, disabled: fieldsDisabled }, [Validators.maxLength(30), Validators.required]),
      ttc: new UntypedFormControl({ value: 0, disabled: fieldsDisabled }, [Validators.maxLength(30), Validators.required]),

      valide: new UntypedFormControl(false),
      facture: new UntypedFormControl(false),
      annule: new UntypedFormControl(false),
      retour: new UntypedFormControl(false),
      blocque: new UntypedFormControl(false),

      dBp: new UntypedFormControl({ value: '', disabled: fieldsDisabled }),
      dCreation: new UntypedFormControl(Date.now()),
      dRegl: new UntypedFormControl({ value: '', disabled: true }),
      dFacture: new UntypedFormControl({ value: '', disabled: true }),
      dAnnulation: new UntypedFormControl({ value: '', disabled: true }),

      bpLines: new UntypedFormArray([]),
    });
    return bpForm;
  }

  getBpFiltreFormGroup(): UntypedFormGroup {
    const bpForm = new UntypedFormGroup({
      siteLib: new UntypedFormControl('', Validators.required),
      siteLivraisonLib: new UntypedFormControl('', Validators.required),
      dBp: new UntypedFormControl({ value: '', disabled: true }),
      fournisseurLib: new UntypedFormControl('', Validators.required),
      refFourn: new UntypedFormControl('', Validators.maxLength(30)),
      nBpMin: new UntypedFormControl('', Validators.maxLength(30)),
      nBpMax: new UntypedFormControl('', Validators.maxLength(30)),
      nBcMin: new UntypedFormControl('', Validators.maxLength(30)),
      nBcMax: new UntypedFormControl('', Validators.maxLength(30)),
      valide: new UntypedFormControl(false),
      bloque: new UntypedFormControl(false),
      facture: new UntypedFormControl(false),
      annule: new UntypedFormControl(false),
      observation: new UntypedFormControl('', Validators.maxLength(255))
    });
    return bpForm;
  }

  public createBpLine(bpForm: UntypedFormGroup): UntypedFormGroup {
    const bpLine = new BpLineModel();
    const i = this.detailBpLineInfosSource.length;
    bpLine.codeCa1 = bpForm.get('codeCa1').value;
    bpLine.libelleCa1 = bpForm.get('libelleCa1').value;
    const row = this.getBpLineForm(bpLine, BPLINEVALIDATORS.CREATE, i);
    // Initializing designation field when article is selected in table field autocomplete
    this.getBpLineRef(i);
    this.getBpLineFormEvent(row, i);
    row.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    return row;
  }

  createBp(bp: BpModel): void {
    this.bp = bp;
    this.societeService.get(this.bp.idSociete).subscribe(r => {
      this.state.changeSociety(r);
    });
    const dialogRef = this.dialog.open(SpinnerModalComponent);
    this.bpService.toInvoice(this.bp).subscribe((res: any) => {
      if (res.id) {
        dialogRef.close();
        this.router.navigate(['/read-bp/' + res.id]);
        this.toastr.success('Création du bon à payer réussi');
      }
    }, (error) => dialogRef.close());
  }

  getCreatedBp(): BpModel {
    return this.bp;
  }

  closeEditBp(): Observable<any> {
    const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Fermer la page de l\'édition du Bp',
        message: 'Êtes-vous sûr de supprimer tous les modifications entrées ?',
        color: 'primary',
        icon_color: 'accent',
      }
    });

    return dialogConfirmation.afterClosed().pipe(res => {
      if (res) {
        this.router.navigate(['/']);
      } else {
        return of(null);
      }
    });
  }

  updateBp(bp: BpModel): Observable<BpModel> {
    if (bp.id) {
      bp.dModification = new Date(Date.now());
      return this.bpService.updateFacturation(bp).pipe(tap(bcUpd => {
      }));
    }
    else {
      this.toastr.error('Erreur lors de la sauvegarde');
    }
  }

  deleteDocument(idBp: number, idDoc: number): Observable<number> {
    const avancement = new BehaviorSubject<number>(0);
    this.documentService.deleteDocBp(idDoc, idBp).pipe(switchMap(doc => {
      avancement.next(80);
      return this.documentService.delete(idDoc);
    })).subscribe(sub => {
      avancement.next(100);
    });
    return avancement.asObservable();
  }

  getDocumentById(idBp: number, idDoc: number): Observable<Blob> {
    const avancement = new BehaviorSubject<number>(0);
    return this.documentService.getDocBp(idDoc, idBp);
  }

  sendDocument(filename: string, idBp: number, file: File): Observable<number> {
    const avancement = new BehaviorSubject<number>(0);
    this.documentService.sendDocBp(filename, idBp, file).pipe(filter((doc: HttpEvent<unknown>) => {
      return doc.type === HttpEventType.Response;
    }),
    switchMap((doc: HttpEvent<unknown>) => {
      avancement.next(80);
      const document = new DocumentModel();
      document.code = filename.substr(0, 30);
      document.libelle = filename;
      document.idBp = idBp;
      return this.documentService.save(document);
    })).subscribe(sub => {
      avancement.next(100);
    }, error => {
      avancement.next(-1);
    });
    return avancement.asObservable();
  }

  memorizeBp(bp: BpModel): Observable<BpModel> {
    // Ajout des libelle et code sur les lignes pour envoie à l'api
    bp.bpLines.forEach((line) => {
      if (line.libelle === '') { line.libelle = '*'; }
      else if (line.code === '') { line.code = '*'; }
    });
    return this.bpService.toInvoice(bp).pipe(tap(bpUpd => {
      this.toastr.success('BP Memorisé !');
    }));
  }

  duplicateBpLineRow(bpLineForm: UntypedFormGroup): any {
    const i = this.detailBpLineInfosSource.length;
    let bpLineDuplicated = new BpLineModel();
    bpLineDuplicated = bpLineForm.value;
    bpLineDuplicated.codeNa = bpLineForm.controls.codeNa.value;
    bpLineDuplicated.libelleNa = bpLineForm.controls.libelleNa.value;
    bpLineDuplicated.codeCgCharge = bpLineForm.controls.codeCgCharge.value;
    bpLineDuplicated.libelleCgCharge = bpLineForm.controls.libelleCgCharge.value;
    const row = this.getBpLineForm(bpLineDuplicated, BPLINEVALIDATORS.CREATE, i);
    return row;
  }

  saveBp(bp: BpModel): Observable<BpModel> {
    const dialogConfirmation = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Vous allez envoyer ce bp pour validation',
        message: 'Êtes-vous sûr des informations entrées ?',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    return dialogConfirmation.afterClosed().pipe(switchMap<string, Observable<BpModel>>(res => {
      if (res != null) {
        const bpToValidate = new BpValidationModel();
        bpToValidate.bp = bp;
        bpToValidate.commentaire = res;

        return this.bpService.validateBp(bpToValidate).pipe(tap(bpUpd => {
          this.toastr.success('BP envoyé pour validation');
        }));
      } else {
        return null;
      }
    }));
  }

}
